export {
  useLogin,
  useLogOut,
  useRefreshToken,
  useCreatePassword,
  useForgotPassword,
  useRecoveryPassword,
  useConfirmEmail,
  useLoginState,
  useBootstrapHook,
  useGetAppScope,
} from './Auth';
export { useAppState, useAuthState } from './State';
export { useValidation, useSortErrors } from './Validation';
export {
  useActiveMenu,
  useGoToForgotPassword,
  useGoToCreatePassword,
  useGoToRecoveryPassword,
  useGoToLogin,
  useGoToMain,
} from './Routes';
export {
  usePopup,
  usePopupStateOperations,
  useIsPopupOpen,
  usePopupData,
} from './Popups';
export {
  useGetAgreementData,
  useStudents,
  useCheckCredentials,
  useLessonsOptions,
  useCreateAgreement,
  useEditStudentWithAgreement,
  useAccountsPayables,
  useStudentPaymentHelpers,
  useStudentDetail,
  usePaymentMutations,
  useContributionMutations,
  useChangeAgreementGroup,
  useAgreementCorrectionCheck,
  useCorrectAgreementGroup,
  useUndoEnrollment,
  AGREEMENT_CORRECT_ROLES,
  ENROLLMENT_UNDO_ROLES,
  CORRECTION_NS,
  CORRECTION_BLOCKER_CODES,
  CORRECTION_WARNING_CODES,
  CORRECTION_CODE_I18N_KEYS,
  TARGET_BLOCKER_CODES,
  blockerKey,
  blockerI18n,
  hasRetryableBlocker,
  titleKeptKey,
  DONE_CHECKLIST_WARNINGS,
  TITLE_KEPT_REASONS,
  warningKey,
  warningsFor,
  visibleCorrectWarnings,
  TARGET_WARNING_CODES,
  splitCorrectBlockers,
  transferIsAlternative,
  useZeroContribution,
  usePaymentCorrections,
  useLmsAccessBlock,
  useLmsSuspensions,
  useLmsBlockHistory,
  useLmsBlockSettings,
  useLmsBlockTemplateExample,
  LMS_SUSPENSIONS_PAGE_SIZE,
  useGroupDebtorCandidates,
  useDebtorCandidateIds,
  useNotes,
  useTasks,
  useStudentPermissions,
  useStudentDeepLinkState,
  useStudentAlerts,
  useStudentAcademic,
  useStaffUsers,
  useStudentMiniCard,
  useTaskSummary,
  useTaskAttachmentUrl,
} from './Students';
export type {
  IStudentDetail,
  IStudentPermissions,
  IAgreementCorrectionCheck,
  ICorrectAgreementGroupArgs,
  ICorrectAgreementGroupResult,
  IUndoEnrollmentResult,
  CorrectionMode,
  IUseStudentDeepLinkState,
  IUseStudentAcademic,
  IDebtorCandidate,
  ILmsBlockActionOptions,
  IUseLmsAccessBlock,
  ILmsSuspensionRow,
  ILmsBlockRobotRun,
  ILmsBlockEvent,
  IUseLmsSuspensions,
  ILmsBlockSendgridTemplate,
  ILmsBlockActionResult,
  IUseLmsBlockSettings,
  INote,
  ITask,
  IStaffUser,
  ITaskSummary,
  IStudentMiniCard,
} from './Students';
export { useCourses, useCoursesForOptions } from './Courses';
export {
  useCompany,
  useCompanies,
  useCreateNewCompany,
  useUpdateCompany,
} from './Companies';
export {
  useJournal,
  useJournals,
  useGroupHomeworkMarks,
  useUpdateAttendance,
  useChangeLessonDate,
  useJournalStudents,
  useUpdateJournalMutation,
  useLoadEditingJournal,
} from './Journals';
export { useModule, useModulesData } from './Module';
export type { IModuleHook } from './Module/ModuleHooks';

export { useSearch, SearchNames } from './Search';
export {
  useLoadMetaHook,
  useTeachersMeta,
  usePageVisiblePoll,
  useDebouncedValue,
} from './Meta';

export {
  usePalette,
  useGlobalHotkey,
  usePaletteSearch,
  SEARCH_DEBOUNCE_MS,
  SEARCH_MIN_CHARS,
  visibleFor,
  STUDENT_ROLES,
  EDUCATION_ROLES,
  EDUCATION_SECTION_ROLES,
  PAYMENT_ACCESS_ROLES,
  MCP_ACCESS_ROLES,
  FINANCE_VIEW_ROLES,
  FINANCE_EXPENSE_ROLES,
  FINANCE_PLAN_ROLES,
  ADMIN_ROLES,
  ZOOM_ROLES,
  SURVEY_ROLES,
  CAREER_ROLES,
  PERFORMANCE_ROLES,
  DOFIN_ROLES,
  ATTENDANCE_EDIT_ROLES,
} from './Palette';
export type {
  IUsePalette,
  IUsePaletteSearch,
  IPaletteSearchResults,
} from './Palette';

export { useGoToKeys, GOTO_TARGETS } from './Shortcuts';

// ТЗ 0093: реестр раздела «Настройки» — хаб, меню, палитра, маршруты.
export * from './Settings';
export type { IGoToTarget } from './Shortcuts';

export { useGetConfirmPopupData } from './Popups/useGetConfirmPopupData';

export { useToasts } from './Toast';

export * from './Teachers';
export * from './Groups';
export * from './Debtors';
export * from './Users';
export * from './Finances';
export * from './Applications';
export * from './Countries';
export * from './Performances';
export * from './Zoom';
export * from './Pandadoc';
export * from './Language';
export * from './Fakturownia';
export * from './Communications';
export * from './Whiteboard';
export * from './Surveys';
export * from './Homeworks';
export * from './CareerCenter';

export { useMyMcpAccess, useRevokeMcpConnection } from './McpAccess';
export * from './Dofinansowanie';
export * from './Esign';
export * from './ShortLinks';
export * from './Sms';
export * from './Crm';
export * from './Marketing';
export * from './Correspondence';
export * from './Notifications';
